/**
 * Strips spaces, hyphens, and all special characters except '+' from a search
 * term so that phone numbers entered in various formats (e.g. "+91 98765-43210"
 * or "(+91) 987 654 3210") are normalised before a contains-search is sent to
 * the API.
 *
 * The '+' sign is intentionally preserved because it is part of the
 * international dialling prefix (e.g. +91).
 *
 * Examples:
 *   "+91 98765-43210"   → "+9198765432​10"
 *   "(+91) 987 654 3210"→ "+91987654​3210"
 *   "987-654-3210"      → "9876543210"
 *   "John Doe"          → "JohnDoe"
 */
export function sanitizeSearchTerm(term: string): string {
    return term.replace(/[^a-zA-Z0-9+]/g, '');
}
